/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

// iPad mini screen width
// http://stephen.io/mediaqueries/#iPadMini
export const DATEPICKER_ENABLE_BREAKPOINT: number = 768;
